import ServiceEndpointsUtil from '../../../../../util/ServiceEndpointsUtil';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import UnifiedSignupPersona from '../session-info/UnifiedSignupPersona';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSignupScreen from './AbstractStartSignupScreen';

export default class StandardStartSignupScreen extends AbstractStartSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-standard';

  public predicate(): boolean {
    return (
      this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard) &&
      this.sessionInfo.value.emailCheckCode === null
    );
  }

  public override async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.intent = UnifiedSignupIntent.standardIntent;
    this.sessionInfo.value.chosenPlan = UnifiedSignupPlan.standard;
    this.sessionInfo.value.persona = UnifiedSignupPersona.proPerson;

    const redirectField = this.getField('signupRedirectUrl');
    const redirectToDomain = ServiceEndpointsUtil.mapDomain('https://cad.onshape.com');
    const redirectTo = `${redirectToDomain}/pro/upgrade/plan/STANDARD_YEARLY`;
    redirectField.val = redirectTo; // redirect to purchase page when activated
    return super.toNextScreen();
  }
}
